import values from 'lodash/values'

import { getConnectedNodesMap } from 'common/builder/selectors/builder/getConnectedNodesMap'

export const getConnectedNodes = (state: RootState, builderId: string, nodeId: string) => {
  const map = getConnectedNodesMap(state, builderId, nodeId)
  return values(map)
}
